 
import { getSkillpathShareUrl } from "../services/courseService";
import { API_PARAM } from "../constants/apiParams";
import env from "env";

export const openLinkedinWindowPopup = (userBadgeId) => {
  const windowWidth = 650;
  const windowHeight = 715;
  const windowTop = (window.screen.height - windowHeight) / 2;
  const windowLeft = (window.screen.width - windowWidth) / 2;

  // These options are used to open the linkedin share popup in the center of the screen
  let windowTitle = "LinkedIn Share";
  let windowOptions = `status=1
    ,width= ${windowWidth}
    ,height= ${windowHeight}
    ,top= ${windowTop}
    ,left= ${windowLeft}`;

  // Make an api call with the userBadgeId to get the accessToken and thumbnailUrl
  getSkillpathShareUrl(userBadgeId).then((res) => {
    let token = res.data.accessToken;
    // This is the url that will be shared on linkedin for the badge HTML Page
    let socialUrl = `${API_PARAM.LINKEDIN_SHARE_URL}${
      env.REACT_APP_API_ENDPOINT
    }${API_PARAM.SHARE_BADGE_URL}${encodeURIComponent(token)}`;
    // Handler to call the linkedin share window popup
    window.open(socialUrl, windowTitle, windowOptions);
  });
};
